import React, { useEffect } from 'react';

/**
 * Render a script tag with the provided attributes.
 * @param {React.ScriptHTMLAttributes<HTMLScriptElement>} scriptProps 
 */
export default function ScriptTag(scriptProps) {
    useEffect(() => {
        const script = document.createElement('script');

        Object.keys(scriptProps).forEach((key) => {
            if (key === 'dangerouslySetInnerHTML') {
                script.innerHTML = scriptProps[key].__html;
            } else {
                if (typeof scriptProps[key] === 'boolean') {
                    script[key] = scriptProps[key]; // For boolean attributes like async
                } else {
                    script.setAttribute(key, scriptProps[key]);
                }
            }
        });

        document.body.appendChild(script);

        return () => {
            // Clean up the script tag when the component unmounts
            document.body.removeChild(script);
        };
    }, [scriptProps]);

    // stubs for the script tag
    return <></>
}
